import { parseDate, roundToXDecimals } from '@ais-ui/utils';
import { QueryPointResult } from './extractTargetInfo';
import {
  extractEnvironmentalWindReport,
  WindReport,
} from './EnvironmentalReports/windReport';
import {
  extractEnvironmentalWeatherReport,
  WeatherReport,
} from './EnvironmentalReports/weatherReport';
import {
  extractEnvironmentalSeaStateReport,
  SeaStateReport,
} from './EnvironmentalReports/seaStateReport';

export interface EnvironmentalTargetInfo {
  latitude: number;
  longitude: number;
  reportTimestamp: Date | null;
  siteId: string;
  stationName: string;
  dataTimeout: string;
  owner: string;
  lastOrigin: string;
  mmsi: string;
  windReport?: WindReport;
  weatherReport?: WeatherReport;
  seaStateReport?: SeaStateReport;
}

const desiredTargetName: string[] = [
  'lastorigin',
  'report_timestamp',
  'Latitude',
  'Longitude',
  'mmsi',
  'owner',
  'data_timeout',
  'site_id',
  'station_name',
];

export function extractEnvironmentalTargetInfos(
  result: QueryPointResult
): EnvironmentalTargetInfo[] {
  const environmentalTargetInfos: EnvironmentalTargetInfo[] = [];
  for (const target of result.targetInfo) {
    const rawEnvironmentalTargetInfo: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(target.values_json)) {
      if (desiredTargetName.includes(key)) {
        rawEnvironmentalTargetInfo[key] = value;
      }
    }
    for (const target_value of target.values) {
      // Here we map values by their ID
      if (desiredTargetName.includes(target_value.id)) {
        rawEnvironmentalTargetInfo[target_value.id] = target_value.value;
      }
    }
    const windReport = target.values_json['wind_report']
      ? extractEnvironmentalWindReport(result)
      : undefined;
    const weatherReport = target.values_json['weather_report']
      ? extractEnvironmentalWeatherReport(result)
      : undefined;
    const seaStateReport = target.values_json['sea_state_report']
      ? extractEnvironmentalSeaStateReport(result)
      : undefined;

    const environmentalInfo: EnvironmentalTargetInfo = {
      lastOrigin: rawEnvironmentalTargetInfo['lastorigin'],
      latitude: target['lat']
        ? roundToXDecimals(target['lat'], 4)
        : target['lat'],
      longitude: target['lon']
        ? roundToXDecimals(target['lon'], 4)
        : target['lon'],
      mmsi: rawEnvironmentalTargetInfo['mmsi'],
      reportTimestamp: parseDate(
        rawEnvironmentalTargetInfo['report_timestamp']
      ),
      siteId: rawEnvironmentalTargetInfo['site_id'],
      stationName: rawEnvironmentalTargetInfo['station_name'],
      dataTimeout: rawEnvironmentalTargetInfo['data_timeout'],
      owner: rawEnvironmentalTargetInfo['owner'],
      windReport: windReport,
      weatherReport: weatherReport,
      seaStateReport: seaStateReport,
    };
    environmentalTargetInfos.push(environmentalInfo);
  }

  return environmentalTargetInfos;
}
